const API_URLS = {
  getBalanceOptions: 'https://api-mobile-ci-vfal.vodafone.com/enterprise-resources/public/service/service-account-adjustments/',
  getDataOptions: 'https://api-mobile-ci-vfal.vodafone.com/enterprise-resources/public/service/service-account-adjustments/',
  getVcoinsOptions: 'https://api-mobile-ci-vfal.vodafone.com/auth/serviceAccountAdjustmentAPI/v2/serviceAccountAdjustment',
  tranferBalance: 'https://api-mobile-ci-vfal.vodafone.com/enterprise-resources/public/service/service-account-adjustments',
  transferData: 'https://api-mobile-ci-vfal.vodafone.com/enterprise-resources/public/service/service-account-adjustments',
  transferVcoins: 'https://api-mobile-ci-vfal.vodafone.com/auth/serviceAccountAdjustmentAPI/v2/serviceAccountAdjustment',
}

export { API_URLS }
